module.exports = __webpack_public_path__ + "files/ee1a235c976ffc4d35088fc0bc808fe0.png";